<template>
  <div class="AccountNotFound">
    <div class="row mt-5">
      <div class="col-md-8 offset-md-2 mt-5 text-center">
        <h1 class="mt-5 pt-5">Account not found.</h1>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AccountNotFound",
  computed: {
    client() {
      let client = this.$store.state.client;
      if (client.name != "") {
        this.$router.push({ name: "Home" });
      }
      return client;
    }
  }
};
</script>
